
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedback/anonymous",
      function () {
        return require("private-next-pages/feedback/anonymous.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feedback/anonymous"])
      });
    }
  